import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=9c9661c8&scoped=true&"
import script from "./MobileMenuButton.vue?vue&type=script&lang=js&"
export * from "./MobileMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9661c8",
  null
  
)

export default component.exports